import client from './client';
import qs from 'qs';

/**
 * 로그인처리
 * @param {아이디, 이동타입} param
 */
export const userOnLogin = (ADVER_ID, type, url) =>
  client.post(
    '/api/move/combine',
    qs.stringify({ userId: ADVER_ID, type: type, url: url })
  );
